module.exports = __webpack_public_path__ + "fonts/Manrope-700-latin-ext23.4e3c84a.woff2";